import { RendererRegistry } from './registry';
import { type IRenderer } from './types';

let globalRegistry: RendererRegistry | null = null;

/**
 * 获取全局渲染器注册表实例
 * @returns 全局注册表实例
 */
export function getRendererRegistry(): RendererRegistry {
  if (!globalRegistry) {
    globalRegistry = new RendererRegistry();
  }
  return globalRegistry;
}

/**
 * 便捷的渲染器注册方法
 * @param name - 渲染器名称
 * @param renderer - 渲染器实例
 */
export function registerRenderer(name: string, renderer: IRenderer): void {
  const registry = getRendererRegistry();
  registry.register(name, renderer);
}

/**
 * 重置全局注册表（主要用于测试）
 */
export function resetRendererRegistry(): void {
  globalRegistry = null;
}
